export const combineSectionIds = (sectionIds) => {
  return sectionIds.reduce((prev, curr) => {
    if (prev) {
      return `${prev},${curr}`;
    } else {
      return curr;
    }
  }, undefined);
};
